export const MuiBackdrop = (palette) => ({
  root: {
    backgroundColor: palette.common.colors.blueDarker,
    opacity: '0.75 !important' // It's set to 1 as an element style
  }
});
